import React, { Component } from 'react';
import './Content.css';
import {ajax} from "../../Context";
import Spinner from "../Elements/Spinner/Spinner";

const AJAX_TYPE = 135799;

class PublicContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:null,
            loading:false
        };
    }
    componentDidMount(prevProps, prevState, snapshot) {
        fetch(ajax.url + '?type=' + AJAX_TYPE + '&page=' + this.props.route + '&uhash=' + this.props.hash)
            .then(response => response.json())
            .then(data => this.setState({data}));
    }

    render() {
        var c = 'typo-pagecontent ' + this.props.route;
        if(this.state.data) {
            if(this.state.data.content) {
                return <div className={c} dangerouslySetInnerHTML={{__html:this.state.data.content}} />
            }else{
                return <span className={c}></span>;
            }
        }else{
            return <Spinner message="" />;
        }
    }
}

export default PublicContent;


// WEBPACK FOOTER //
// ./src/Components/Content/PublicContent.js